export const exportURLs = {
  individualProperty_members: "above-property/members/export",
  individualProperty_plans: "above-property/plans/export",
  corp_properties: "view/properties/summary/export",
  corp_plans: "view/plans/summary/export",
  admin_console: "corporate/permissions/export",
  feedback: "plans/feedback/export",
  aboveProperty_propertiesPaged: "above-property/properties-paged/export",
  aboveProperty_plans: "above-property/plans/export",
  aboveProperty_unimplementedProperties: "above-property/unimplemented-properties/export",
  aboveProperty_assignedAndTemplatePlans: "above-property/assigned-plans/export",
  aboveProperty_brandAndInitiativePlans: "plans/multi-target/export"
};
